(() => {
  const svg = `
    <svg width="20" height="20" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"/>
    </svg>`;

  function tryInsert() {
    const button = document.getElementById("dyn-checkout");
    if (!button) return false;
    if (!button.querySelector("svg")) {
      button.insertAdjacentHTML("afterbegin", svg);
    }

    let label = button.querySelector(".dyn-checkout-label");
    if (!label) {
      label = document.createElement("span");
      label.className = "dyn-checkout-label";
      label.textContent = "SECURE";
      const icon = button.querySelector("svg");
      if (icon) {
        icon.insertAdjacentElement("afterend", label);
      } else {
        button.appendChild(label);
      }
    } else if (label.textContent !== "SECURE") {
      label.textContent = "SECURE";
    }
    return true;
  }

  // --- Cart title (YOUR CART) count sync ---
  let subtotalObserver = null;

  function extractCartCount() {
    const subtotal = document.querySelector(".dyn-subtotal-items");
    if (!subtotal) return null;
    const text = subtotal.textContent || "";
    const match = text.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  function ensureHeaderLeftSpan() {
    let left = document.querySelector(".dyn-heading-text-left");
    if (left) return left;
    const title = document.querySelector(".dyn-cart-heading-title");
    if (!title) return null;
    left = document.createElement("span");
    left.className = "dyn-heading-text-left";
    title.prepend(left);
    return left;
  }

  function updateCartTitleCount() {
    const count = extractCartCount();
    const left = ensureHeaderLeftSpan();
    if (!left) return false;
    // Cache base title to avoid compounding parentheses
    if (!left.dataset.baseTitle) {
      const current = left.textContent || "";
      left.dataset.baseTitle = current.replace(/\s*\(\d+\)\s*$/, "").trim() || current.trim() || "YOUR CART";
    }
    left.textContent = Number.isFinite(count) ? `${left.dataset.baseTitle} (${count})` : left.dataset.baseTitle;
    // Clear any right-side legacy count if present
    const right = document.querySelector(".dyn-heading-text-right");
    if (right) right.textContent = "";
    return true;
  }

  function updateEmptyCartButton() {
    const emptyBtn = document.querySelector(".dyn-empty-cart-btn-action");
    if (emptyBtn && emptyBtn.textContent === "Shop Now") {
      emptyBtn.textContent = "Shop All Products";
    }
  }

  function updateEmptyCartSubtitle() {
    const subtitle = document.querySelector(".dyn-empty-cart-subtitle");
    if (subtitle) {
      subtitle.textContent = "Smarter nicotine starts here.";
    }
  }

  function updateEmptyCartTitle() {
    const title = document.querySelector(".dyn-empty-cart-title");
    if (title) {
      title.textContent = "Your cart is empty";
    }
  }

  function injectEmptyCartProducts() {
    const bodyWidget = document.querySelector(".dyn-empty-cart-body-widgets");
    if (!bodyWidget || bodyWidget.querySelector(".menu-drawer__navigation")) return false;

    const html = `
    <div class="mobile-menu">
      <nav class="menu-drawer__navigation">
        <div class="mm-body" style="padding: 0px 15px !important; background: #fff; overflow-y: unset;">
          <div class="mm-top">
            <a href="/products/breakers" class="mm-card">
              <img
                class="mm-thumb"
                src="https://cdn.shopify.com/s/files/1/0039/5093/6137/files/Breakers_4MG_ALL_FLAVORS_2dc9c879-340a-47fb-8702-02f94c5070f7.webp?v=1776971649"
                alt="The Breakers"
                loading="lazy"
                width="64"
                height="47"
              >
              <div>
                <div class="mm-title">THE BREAKERS</div>
                <p class="mm-desc">
                  Pouches with a burstable flavor capsule.
                </p>
              </div>
            </a>
            <a href="/products/pouches" class="mm-card">
              <img
                class="mm-thumb"
                src="https://cdn.shopify.com/s/files/1/0039/5093/6137/files/pouches-megamenu.webp"
                alt="The Pouches"
                loading="lazy"
                width="64"
                height="47"
              >
              <div>
                <div class="mm-title">THE POUCHES</div>
                <p class="mm-desc">
                  Discreet, tobacco-free pouches for long-lasting nicotine and flavor.
                </p>
              </div>
            </a>
            <a href="/products/gum" class="mm-card">
              <img
                class="mm-thumb"
                src="https://cdn.shopify.com/s/files/1/0039/5093/6137/files/gum-megamenu.webp"
                alt="The Gum"
                loading="lazy"
                width="64"
                height="47"
              >
              <div>
                <div class="mm-title">THE GUM</div>
                <p class="mm-desc">
                  Chewable nicotine for on-the-go satisfaction.
                </p>
              </div>
            </a>
          </div>
        </nav>
      </div>
    `;

    bodyWidget.insertAdjacentHTML("beforeend", html);
    return true;
  }

  function startSubtotalObserver() {
    if (subtotalObserver) return true;
    const subtotal = document.querySelector(".dyn-subtotal-items");
    if (!subtotal) return false;
    subtotalObserver = new MutationObserver(() => {
      // batch updates to avoid excessive recalculations while the cart updates
      scheduleUpdate();
    });
    subtotalObserver.observe(subtotal, { childList: true, subtree: true, characterData: true });
    // Initial sync after attaching
    updateCartTitleCount();
    return true;
  }

  let rafId = 0;
  function scheduleUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      try {
        tryInsert();
        updateCartTitleCount();
        updateEmptyCartButton();
        updateEmptyCartSubtitle();
        updateEmptyCartTitle();
        injectEmptyCartProducts();
      } catch (_) {
        /* no-op */
      }
    });
  }

  function waitAndInsert(timeoutMs = 10000) {
    // Attempt immediately (batched)
    scheduleUpdate();

    const observer = new MutationObserver(() => {
      scheduleUpdate();
      if (startSubtotalObserver()) observer.disconnect();
    });

    const scope = document.getElementById("dyn-cart-container") || document.body;
    observer.observe(scope, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), timeoutMs);
  }

  // Watch for empty cart section appearing (when items are removed)
  let emptyObserver = null;
  function observeEmptyCartSection() {
    if (emptyObserver) return; // Already observing

    emptyObserver = new MutationObserver(() => {
      const emptySection = document.getElementById("dyn-empty-cart-section");
      if (emptySection && emptySection.offsetParent !== null) {
        scheduleUpdate();
      } else {
        // Empty section not visible, check if cart has items
        const cartItems = document.querySelector(".dyn-cart-items-container");
        if (cartItems && cartItems.children.length > 0) {
          // Cart has items, disconnect to reduce overhead
          if (emptyObserver) {
            emptyObserver.disconnect();
            emptyObserver = null;
          }
        }
      }
    });

    const scope = document.getElementById("dyn-cart-container") || document.body;
    emptyObserver.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  window.addEventListener("dyn_cart_open", () => {
    waitAndInsert();
    observeEmptyCartSection();
  });

  // Listen for cart updates to restart observer if items removed
  window.addEventListener("cart:updated", observeEmptyCartSection);
  window.addEventListener("cart:change", observeEmptyCartSection);

  // Also run on load in case cart is already open
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeEmptyCartSection);
  } else {
    observeEmptyCartSection();
  }
})();
